import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Table from '@result/result-ui-components/src/components/Table';
import {useDispatch, useSelector} from 'react-redux';
import Filter from './Filter';
import Button from '@result/result-ui-components/src/components/Button';
import {setLocationListFilter} from "../../state/filter/filterValues";

const IllegalDumpingLocationsTable = (props) => {
	const { columns, onClick } = props;
	const { t } = useTranslation();
	const navigate = useNavigate();

	const dispatch = useDispatch();
	const [isFetching, setIsFetching] = useState(false);
	const [isLastPage, setIsLastPage] = useState(false);
	const [currentPage, setCurrentPage] = useState({page: 0, size: 10});
	const [fetchedRows, setFetchedRows] = useState([]);
	const [sort, setSort] = useState({});
	const [filter, setFilter] = useState([]);

	const initialFilterFromStore = useSelector((state) => state.filterValues.locationListFilter);
	const [initialFilter] = useState(initialFilterFromStore);

	useEffect(() => {
		fetchData(currentPage, filter, sort);
	}, [currentPage, filter, sort]);


	const handleScroll = () => {
		if(isFetching) {
			return;
		}
		if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight) {
			setCurrentPage({...currentPage, page: currentPage.page + 1});
		}
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		window.addEventListener("wheel", handleScroll);
		window.addEventListener("touchmove", handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
			window.removeEventListener("wheel", handleScroll);
			window.removeEventListener("touchmove", handleScroll);
		}
	})

	function onRowClick(entry) {
		if (props.disableOnClick) {
			return;
		}
		onClick ? onClick() : navigate(t('navigation.href.edit') + '/' + entry.id);
	}

	function fetchData(page, filter, sort) {
		if(isLastPage) {
			return;
		}
		let params = { page: page, filter: filter, sort: sort };
		const sortKeys = Object.keys(sort);
		if(sortKeys.length !== 0) {
			const sortKey = sortKeys[0];
			if(sortKey !== 'id' && sort[sortKey] !== 'none') {
				params.sort = `sort=${sortKey},${sort[sortKey]}&sort=id,asc`;
			}
		}
		if (props?.fetchId) {
			params.id = props.fetchId;
		}
		setIsFetching(true);
		dispatch(props.fetchAction(params))
			.then(async (res) => {
				setIsLastPage(res.payload.content.length < currentPage.size);
				if(page.page === 0) {
					setFetchedRows(res.payload.content);
				} else {
					setFetchedRows([...fetchedRows, ...res.payload.content]);
				}
				setIsFetching(false);
				if (props.refetchData) props.onDataRefetched();
			})
			.catch(async () => {
				setIsFetching(false);
				if (props.refetchData) props.onDataRefetched();
			});
	}

	useEffect(() => {
		if (props.refetchData) fetchData();
	}, [props.refetchData]);

	return (
		<div>
			<div className="card table-card has-overflow-y-auto">
				<div className="is-flex is-justify-content-space-between is-align-items-start p-4">
					{props.showCreateButton && (
						<Button
							color="primary"
							label={props.createButtonLabel || t('create_new')}
							onClick={() => navigate(t('navigation.href.create'))}
						/>
					)}
					{props.filterColumns && props.filterColumns.length > 0 && (
						<Filter
							columns={props.filterColumns}
							filter={filter}
							onFilter={(filter, formFilterValues) => {
								dispatch(setLocationListFilter(formFilterValues));
								setIsLastPage(false);
								setCurrentPage({...currentPage, page: 0});
								setFilter(filter);
							}}
							initialFilter={initialFilter}
							filterIcon={props.filterIcon}
						/>
					)}
				</div>
				<div className="card-content">
					<Table
						columns={columns}
						data={fetchedRows}
						onSelection={(entry) => onRowClick(entry)}
						onSort={(sort) => {
							setIsLastPage(false);
							if(props.groupRowsBy) {
								return;
							}
							setCurrentPage({...currentPage, page: 0});
							setSort(sort);
						}}
						sort={sort}
						groupRowsBy={props.groupRowsBy}
					/>
					{isLastPage && (fetchedRows.length > 0) && <div className="has-text-centered has-text-grey-light	">Konec zadetkov</div>}
				</div>
			</div>
		</div>
	);
};

IllegalDumpingLocationsTable.propTypes = {
	selector: PropTypes.func.isRequired,
	fetchAction: PropTypes.func.isRequired,
	columns: PropTypes.array.isRequired,
	onClick: PropTypes.func,
	disableOnClick: PropTypes.bool,
	createButtonLabel: PropTypes.string,
	showCreateButton: PropTypes.bool,
	defaultSort: PropTypes.string,
	groupRowsBy: PropTypes.string,
	filterColumns: PropTypes.arrayOf(PropTypes.object),
	defaultFilter: PropTypes.string,
	isInfiniteScroll: PropTypes.bool,
};

export default IllegalDumpingLocationsTable;
